module.exports = __webpack_public_path__ + "img/Step10.3a453a57.png";